import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ImportAccountContent from './ImportAccountContent';
import { Button } from '../../components/';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { openModal } from '../../components/modal/actions';

export const ImportAccountModal = ({ openModal }) => {
  const handleClick = () => {
    openModal({ type: 'custom', element: <ImportAccountContent /> });
  };

  return (
    <Button
      type='button'
      textLink
      matchCase
      extraClassName='profile__edit_button p0-sm body-4'
      onClick={handleClick}
      data-desc='editProfileAccounts__button_import-account'
      key='testing'
    >
      <TranslatedCopy id='profile.sidebar.importing.copy2' />
    </Button>
  );
};

ImportAccountModal.propTypes = {
  openModal: PropTypes.func.isRequired
};

const connector = connect(() => ({}), {
  openModal
});

export default connector(ImportAccountModal);
